const BLOG_COVERS = 'blog-covers';
const BLOG_OG = 'blog-og';
const BLOG_CONTENT = 'blog-content';
const SUCCESS_STORY_COVERS = 'success-story-covers';
const SUCCESS_STORY_OG = 'success-story-og';
const SUCCESS_STORY_CONTENT = 'success-story-content';

module.exports = {
  BLOG_COVERS,
  BLOG_OG,
  BLOG_CONTENT,
  SUCCESS_STORY_COVERS,
  SUCCESS_STORY_OG,
  SUCCESS_STORY_CONTENT,
};
